module.exports = __webpack_public_path__ + "static/media/1POLICY35.f6857310.jpg";